<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal(
          :class="'modal_notification-' + widthType"
          @click="onClickWrapper($event)"
        )
          .modal__body
            .modal-content
              .modal-content__text(
              :class="'modal-content__text_align-' + textFloat"
              v-html="text.length > 0 ? text : 'Анкета успешно сохранена!'"
              )
              .modal-content__buttons-container
                button.button.button_paint-main.button_full(
                  v-focus
                  @click.prevent="$emit('close')"
                )
                  .button__text Спасибо
</template>

<script>
export default {
  name: "NotificationModal",
  props: {
    text: {
      type: String,
      default: ""
    },
    widthType: {
      type: String,
      default: "small"
    },
    textFloat: {
      type: String,
      default: "center"
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    },
    onSubmitMethod(e) {
      e.preventDefault();
    }
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted() {}
};
</script>
